var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section-title", { staticClass: "mt-2" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.applicantName) +
            ",\n    " +
            _vm._s(
              _vm.$t(
                "application-standalone.pages.properties.tellUsAboutThisProperty"
              )
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _vm.otherPropertyOccupancyVisibility ||
      _vm.otherPropertyAddressVisibility ||
      _vm.otherPropertyPurchasePriceVisibility ||
      _vm.otherPropertyEstimatedValueVisibility ||
      _vm.otherPropertyPurchaseDateVisibility
        ? _c(
            "span",
            [
              _c(
                "b-row",
                [
                  _vm.otherPropertyAddressVisibility
                    ? _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "page-section-group-layout",
                            [
                              _c(
                                "section-title",
                                { staticClass: "mb-4" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-form.property-address"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                  _vm.getValidator("address.required")
                                    ? _c("input-required-indicator")
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.showCopyPreviousAddress
                                ? _c("select-field", {
                                    attrs: {
                                      value: null,
                                      label: _vm.$t(
                                        "application-standalone.pages.properties.selectPreviousAddress"
                                      ),
                                      placeholder: _vm.$t(
                                        "application-standalone.pages.properties.selectPreviousAddress"
                                      ),
                                      options: _vm.addressesAsOptions,
                                    },
                                    on: {
                                      "update:value": _vm.handleAddressCopy,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        _vm.showCopiedIndicator
                                          ? {
                                              key: "prepend-input",
                                              fn: function () {
                                                return [
                                                  _c("icon", {
                                                    staticClass: "text-primary",
                                                    attrs: { name: "check" },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-primary small",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "application.actions.copied"
                                                            )
                                                          ) +
                                                          "\n              "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("address-field-group", {
                                ref: "addressFieldComponent",
                                attrs: {
                                  line1: _vm.address.line1,
                                  line2: _vm.address.line2,
                                  "unit-number": _vm.address["unit-number"],
                                  province: _vm.address.province,
                                  city: _vm.address.city,
                                  "postal-code": _vm.address["postal-code"],
                                  "street-direction":
                                    _vm.address["street-direction"],
                                  "street-name": _vm.address["street-name"],
                                  "street-number": _vm.address["street-number"],
                                  "street-type": _vm.address["street-type"],
                                  validator: _vm.getValidator("address"),
                                  label: _vm.$t(
                                    "application-form.property-address"
                                  ),
                                  "hidden-label": "",
                                  "show-required-indicator": "",
                                },
                                on: {
                                  "update:line1": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "line1",
                                      $event
                                    )
                                  },
                                  "update:line2": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "line2",
                                      $event
                                    )
                                  },
                                  "update:unitNumber": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "unit-number",
                                      $event
                                    )
                                  },
                                  "update:unit-number": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "unit-number",
                                      $event
                                    )
                                  },
                                  "update:province": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "province",
                                      $event
                                    )
                                  },
                                  "update:city": function ($event) {
                                    return _vm.$set(_vm.address, "city", $event)
                                  },
                                  "update:postalCode": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "postal-code",
                                      $event
                                    )
                                  },
                                  "update:postal-code": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "postal-code",
                                      $event
                                    )
                                  },
                                  "update:streetDirection": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "street-direction",
                                      $event
                                    )
                                  },
                                  "update:street-direction": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "street-direction",
                                      $event
                                    )
                                  },
                                  "update:streetName": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "street-name",
                                      $event
                                    )
                                  },
                                  "update:street-name": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "street-name",
                                      $event
                                    )
                                  },
                                  "update:streetNumber": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "street-number",
                                      $event
                                    )
                                  },
                                  "update:street-number": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "street-number",
                                      $event
                                    )
                                  },
                                  "update:streetType": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "street-type",
                                      $event
                                    )
                                  },
                                  "update:street-type": function ($event) {
                                    return _vm.$set(
                                      _vm.address,
                                      "street-type",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "align-items-end" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c("section-title", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "application-standalone.questions.otherProperties.owner"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("select-field", {
                            attrs: {
                              value: _vm.propertyOwner,
                              placeholder: _vm.$t(
                                "application-standalone.questions.otherProperties.owner"
                              ),
                              options: _vm.applicantsAsOptions,
                              "allow-empty": false,
                            },
                            on: { "update:value": _vm.handleOwnerChange },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.otherPropertyEstimatedValueVisibility
                    ? _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "page-section-group-layout",
                            [
                              _c(
                                "section-title",
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-standalone.questions.estimatedValue"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                  _vm.getValidator("estimatedValue.required")
                                    ? _c("input-required-indicator")
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("currency-field", {
                                attrs: {
                                  value: _vm.estimatedValue,
                                  placeholder: _vm.$t(
                                    "application-form.estimated-value"
                                  ),
                                  validator: _vm.getValidator("estimatedValue"),
                                  label: _vm.$t(
                                    "application-form.estimated-value"
                                  ),
                                  "hidden-label": "",
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.estimatedValue = $event
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.otherPropertyPurchasePriceVisibility
                    ? _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "page-section-group-layout",
                            [
                              _c(
                                "section-title",
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-standalone.questions.otherProperties.purchasePrice"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                  _vm.getValidator("estimatedValue.required")
                                    ? _c("input-required-indicator")
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("currency-field", {
                                attrs: {
                                  value: _vm.purchasePrice,
                                  placeholder: _vm.$t(
                                    "application-form.purchase-price"
                                  ),
                                  validator: _vm.getValidator("purchasePrice"),
                                  label: _vm.$t(
                                    "application-form.purchase-price"
                                  ),
                                  "hidden-label": "",
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.purchasePrice = $event
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.otherPropertyPurchaseDateVisibility
                    ? _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "page-section-group-layout",
                            [
                              _c(
                                "section-title",
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-standalone.questions.otherProperties.purchaseDate"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                  _vm.getValidator("purchaseDate.required")
                                    ? _c("input-required-indicator")
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("date-field", {
                                attrs: {
                                  value: _vm.purchaseDate,
                                  placeholder: _vm.$t(
                                    "application-form.purchase-date"
                                  ),
                                  validator: _vm.getValidator("purchaseDate"),
                                  label: _vm.$t(
                                    "application-form.purchase-date"
                                  ),
                                  "hidden-label": "",
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.purchaseDate = $event
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyPropertyTaxesVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                { staticClass: "mb-4" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.otherProperties.annualPropertyTaxes"
                        )
                      ) +
                      "\n      "
                  ),
                  _vm.getValidator("propertyTaxes.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "align-items-end" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          value: _vm.propertyTaxes,
                          placeholder: _vm.$t(
                            "application-form.annual-property-taxes"
                          ),
                          validator: _vm.getValidator("propertyTaxes"),
                          label: _vm.$t(
                            "application-form.annual-property-taxes"
                          ),
                          "hidden-label": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.propertyTaxes = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyMaintenanceFeesVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.otherProperties.maintenanceFees"
                        )
                      ) +
                      "\n      "
                  ),
                  _vm.getValidator("maintenanceFees.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          value: _vm.maintenanceFees,
                          placeholder: _vm.$t(
                            "application-standalone.questions.otherProperties.maintenanceFees"
                          ),
                          validator: _vm.getValidator("maintenanceFees"),
                          label: _vm.$t(
                            "application-standalone.questions.otherProperties.maintenanceFees"
                          ),
                          "hidden-label": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.maintenanceFees = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyPercOfTotalMaintFeesVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.otherProperties.percOfTotalMaintFees"
                        )
                      ) +
                      "\n      "
                  ),
                  _vm.getValidator("percOfTotalMaintFees.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("percentage-field", {
                        attrs: {
                          value: _vm.percOfTotalMaintFees,
                          placeholder: _vm.$t(
                            "application-standalone.questions.otherProperties.percOfTotalMaintFees"
                          ),
                          validator: _vm.getValidator("percOfTotalMaintFees"),
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.percOfTotalMaintFees = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyOccupancyVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.otherProperties.occupancy"
                        )
                      ) +
                      "\n      "
                  ),
                  _vm.getValidator("occupancy.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value: _vm.occupancy,
                          options: _vm.propertyDetailsOccupancyOptions,
                          placeholder: _vm.$t(
                            "application-standalone.questions.otherProperties.occupancy"
                          ),
                          validator: _vm.getValidator("occupancy"),
                          label: _vm.$t(
                            "application-standalone.questions.otherProperties.occupancy"
                          ),
                          "hidden-label": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.occupancy = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyFeesIncludeHeatVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.feesIncludeHeat"
                        )
                      ) +
                      "\n      "
                  ),
                  _vm.getValidator("feesIncludeHeat.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("radio-field", {
                        attrs: {
                          value: _vm.feesIncludeHeat,
                          options: _vm.yesNoOptions,
                          validator: _vm.getValidator("feesIncludeHeat"),
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.feesIncludeHeat = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyHeatingVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("application-standalone.labels.heatFees")) +
                      "\n      "
                  ),
                  _vm.getValidator("heating.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          "extra-validation": _vm.extraValidation,
                          value: _vm.heating,
                          placeholder: _vm.$t(
                            "application-standalone.labels.heatFees"
                          ),
                          validator: _vm.getValidator("heating"),
                          label: _vm.$t(
                            "application-standalone.labels.heatFees"
                          ),
                          "hidden-label": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.heating = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyMonthlyIncomeVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("application-standalone.questions.monthlyIncome")
                      ) +
                      "\n      "
                  ),
                  _vm.getValidator("monthlyIncome.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          "extra-validation": _vm.extraValidation,
                          value: _vm.monthlyIncome,
                          placeholder: _vm.$t(
                            "application-form.monthly-income"
                          ),
                          validator: _vm.getValidator("monthlyIncome"),
                          label: _vm.$t("application-form.monthly-income"),
                          "hidden-label": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.monthlyIncome = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyRentalIncomeOptionsVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.otherProperties.rentalIncomeOptions"
                        )
                      ) +
                      "\n      "
                  ),
                  _vm.getValidator("rentalIncomeOptions.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value: _vm.rentalIncomeOptions,
                          options: _vm.propertyRentalIncomeSelectOptions,
                          placeholder: _vm.$t(
                            "application-standalone.questions.otherProperties.rentalIncomeOptions"
                          ),
                          validator: _vm.getValidator("rentalIncomeOptions"),
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.rentalIncomeOptions = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyRentalIncomeOptionsPercentVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.otherProperties.rentalIncomeOptionsPercent"
                        )
                      ) +
                      "\n      "
                  ),
                  _vm.getValidator("rentalIncomeOptionsPercent.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("percentage-field", {
                        attrs: {
                          value: _vm.rentalIncomeOptionsPercent,
                          placeholder: _vm.$t(
                            "application-standalone.questions.otherProperties.rentalIncomeOptionsPercent"
                          ),
                          validator: _vm.getValidator(
                            "rentalIncomeOptionsPercent"
                          ),
                          label: _vm.$t(
                            "application-standalone.questions.otherProperties.rentalIncomeOptionsPercent"
                          ),
                          "hidden-label": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.rentalIncomeOptionsPercent = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyHydroVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.otherProperties.hydro"
                        )
                      ) +
                      "\n      "
                  ),
                  _vm.getValidator("hydro.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          "extra-validation": _vm.extraValidation,
                          value: _vm.hydro,
                          placeholder: _vm.$t(
                            "application-standalone.labels.hydroFees"
                          ),
                          validator: _vm.getValidator("hydro"),
                          label: _vm.$t(
                            "application-standalone.labels.hydroFees"
                          ),
                          "hidden-label": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.hydro = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyManagementVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.otherProperties.management"
                        )
                      ) +
                      "\n      "
                  ),
                  _vm.getValidator("management.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          "extra-validation": _vm.extraValidation,
                          value: _vm.management,
                          placeholder: _vm.$t(
                            "application-standalone.labels.managementFees"
                          ),
                          validator: _vm.getValidator("management"),
                          label: _vm.$t(
                            "application-standalone.labels.managementFees"
                          ),
                          "hidden-label": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.management = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyRepairsVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.otherProperties.repairs"
                        )
                      ) +
                      "\n      "
                  ),
                  _vm.getValidator("repairs.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          "extra-validation": _vm.extraValidation,
                          value: _vm.repairs,
                          placeholder: _vm.$t(
                            "application-standalone.labels.repairs"
                          ),
                          validator: _vm.getValidator("repairs"),
                          label: _vm.$t(
                            "application-standalone.labels.repairs"
                          ),
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.repairs = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyOthersVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.otherProperties.otherExpenses"
                        )
                      ) +
                      "\n      "
                  ),
                  _vm.getValidator("others.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          "extra-validation": _vm.extraValidation,
                          value: _vm.others,
                          placeholder: _vm.$t(
                            "application-standalone.labels.otherFees"
                          ),
                          validator: _vm.getValidator("others"),
                          label: _vm.$t(
                            "application-standalone.labels.otherFees"
                          ),
                          "hidden-label": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.others = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyInsuranceVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "application-standalone.questions.otherProperties.insurance"
                      )
                    ) + "\n      "
                  ),
                  _vm.getValidator("insurance.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          "extra-validation": _vm.extraValidation,
                          value: _vm.insurance,
                          placeholder: _vm.$t(
                            "application-standalone.labels.insuranceFees"
                          ),
                          validator: _vm.getValidator("insurance"),
                          label: _vm.$t(
                            "application-standalone.labels.insuranceFees"
                          ),
                          "hidden-label": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.insurance = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherPropertyInterestVisibility
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.otherProperties.interest"
                        )
                      ) +
                      "\n      "
                  ),
                  _vm.getValidator("interest.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          "extra-validation": _vm.extraValidation,
                          value: _vm.interest,
                          placeholder: _vm.$t(
                            "application-standalone.labels.interestFees"
                          ),
                          validator: _vm.getValidator("interest"),
                          label: _vm.$t(
                            "application-standalone.labels.interestFees"
                          ),
                          "hidden-label": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.interest = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "page-section-group-layout",
        [
          _c("section-title", { staticClass: "mb-4" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t(
                    "application-standalone.questions.subjectProperty.existingMortgages"
                  )
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("radio-field", {
            attrs: {
              value: _vm.computedOtherPropertyHasExistingMortgages,
              options: _vm.yesNoOptions,
            },
            on: {
              change: function (val) {
                return _vm.handleChangeIsThePropertyStillMortgaged(
                  val,
                  _vm.applicantIndex,
                  _vm.otherPropertyIndex
                )
              },
            },
          }),
          _vm._v(" "),
          _vm.propertyHasExistingMortgages(_vm.otherProperty)
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _vm._l(
                        _vm.existingMortgages,
                        function (existingMortgage, existingMortgageIndex) {
                          return _c("other-property-existing-mortgage", {
                            key:
                              existingMortgage["lender"] +
                              "-" +
                              existingMortgageIndex,
                            attrs: {
                              "applicant-index": _vm.applicantIndex,
                              "other-property-index": _vm.otherPropertyIndex,
                              "existing-mortgage-index": existingMortgageIndex,
                              "applicant-id": _vm.applicantId,
                            },
                          })
                        }
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          on: {
                            click: function ($event) {
                              return _vm.addExistingMortgage(
                                _vm.applicantIndex,
                                _vm.otherPropertyIndex
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "application-standalone.pages.properties.addAnotherExistingMortgage"
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }